import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import React from "react";

import Header from "../table/table-header";
import GroupInfo from "../sections/group-info";
import { Policy } from "../../constants/aquafina";
import { ComingSoon } from "../comming-soon";

type WrapperDetailsProps = Pick<
  Policy,
  "groupInformation" | "groupContacts" | "billing" | "benefitClasses"
> & {
  planNames: string[];
  children?: React.ReactNode;
};

const WrapperDetails = ({
  planNames,
  children,
  groupInformation,
  groupContacts,
  billing,
  benefitClasses,
}: WrapperDetailsProps) => {
  const numberPlans = planNames?.length || 0;
  return numberPlans ? (
    <TableContainer
      sx={[
        {
          overflowY: "auto",
        },
        numberPlans > 2
          ? {
              overflowX: "scroll",
            }
          : {
              overflowX: "auto",
            },
      ]}
    >
      <Table>
        <TableBody>
          <GroupInfo
            colSpan={numberPlans + 1}
            groupInformation={groupInformation}
            groupContacts={groupContacts}
            billing={billing}
            benefitClasses={benefitClasses}
          />
        </TableBody>
      </Table>
      <Box sx={{ overflowX: "auto" }}>
        <Table stickyHeader sx={{ mt: 4 }}>
          {numberPlans > 1 && (
            <TableHead>
              <Header headers={planNames} />
            </TableHead>
          )}
          <TableBody>{children}</TableBody>
        </Table>
      </Box>
    </TableContainer>
  ) : (
    <ComingSoon />
  );
};

export default WrapperDetails;
